import type { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollTop from "./ScrollTop";

interface AppLayoutProps {
  children: ReactNode;
  overlay?: boolean;
}

export default function AppLayout({ children, overlay = false }: AppLayoutProps) {
  return (
    <div className="paper-grain min-h-screen bg-background-50">
      <Navbar overlay={overlay} />
      <main>{children}</main>
      <Footer />
      <ScrollTop />
    </div>
  );
}